import Swal from 'sweetalert2'
import { recoverDepartamentoDeleted } from '../../../Services/departamentoService'

const useRecover = (setIsLoad) => {
    const recoverDepartamentoSubmit = (departamento) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                recoverDepartamentoDeleted(departamento.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'El departamento fue recuperado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }
    return { recoverDepartamentoSubmit }
}

export default useRecover
